import React from 'react';
import { CheckboxProps } from 'semantic-ui-react';

import { styled } from '@modules/common/components/ThemeProvider/utils';
import Checkbox from '@modules/common/components/Checkbox';

import AllowedOriginsSelection from './AllowedOriginsSelection';
import SelectedAllowedOrigins from './SelectedAllowedOrigins';
import Warning from './Warning';

type Props = {
  isSetupForSPA?: boolean;
  setIsSetupForSPA?: (value: boolean) => void;
  allowedOriginDomains?: string[];
  setAllowedOriginDomains: (origins?: string[]) => void;
  hasAcceptedSPARisk?: boolean;
  setHasAcceptedSPARisk?: (value: boolean) => void;
  isEditing?: boolean;
};

function SPASettings({
  isSetupForSPA,
  setIsSetupForSPA,
  allowedOriginDomains,
  setAllowedOriginDomains,
  hasAcceptedSPARisk,
  setHasAcceptedSPARisk,
  isEditing = false,
}: Props) {
  function onSelectSPASettings(_: any, data: CheckboxProps) {
    if (setIsSetupForSPA) {
      setIsSetupForSPA(Boolean(data.checked));
    }
  }

  return (
    <>
      <Checkbox
        label="Client will be used by a single-page application"
        checked={isSetupForSPA}
        onChange={onSelectSPASettings}
        disabled={isEditing}
      />
      {isSetupForSPA && (
        <StyledSPASettingsWrapper>
          <StyledDomainSelectionWrapper>
            <SelectedAllowedOrigins
              allowedOriginDomains={allowedOriginDomains}
              setAllowedOriginDomains={setAllowedOriginDomains}
            />
            <AllowedOriginsSelection
              allowedOriginDomains={allowedOriginDomains}
              setAllowedOriginDomains={setAllowedOriginDomains}
            />
          </StyledDomainSelectionWrapper>
          <Warning
            hasAcceptedSPARisk={hasAcceptedSPARisk}
            setHasAcceptedSPARisk={setHasAcceptedSPARisk}
          />
        </StyledSPASettingsWrapper>
      )}
    </>
  );
}

export default SPASettings;

const StyledSPASettingsWrapper = styled('div')`
  padding-left: 1rem;
  padding-right: 1rem;
`;

const StyledDomainSelectionWrapper = styled('p')`
  display: flex;
  flex-direction: column;
`;
